<template>
  <div class="flex flex-col py-6" style="min-width: 600px">
    <div class="w-full">
      <div class="flex flex-col">
        <div class="flex flex-col items-center mb-6">
          <div class="px-4 mb-6">
            <img
              alt="..."
              class="shadow rounded max-w-full h-auto align-middle border-none"
              :src="!!user_edit.avatar?user_edit.avatar:imgPlaceholder"
              style="width: 150px;"
            />
          </div>
          <div class="flex flex-col mb-2" v-if="isEdit">
            <p class="text-xs text-gray-700">Minimum 900x900, Maximum 1MB</p>
          </div>
          <div class="flex flex-col mb-2" v-if="isFileLarge || isErrorImage">
            <text-error v-if="isFileLarge" text="Please select correct file" />
            <text-error v-if="isErrorImage" text="Image is Required." />
          </div>
          <div class="flex">
            <Button label="Browse File" v-if="!user_edit.avatar && isEdit">
              <template v-slot:any>
                <input style="width: 100%;height: 100%;position: absolute;left: 0;top: 0;opacity: 0;cursor: pointer;z-index: 2;"
                       type="file"
                       name="profile_picture"
                       @change="onFileChange"
                />
              </template>
            </Button>
            <Button label="Cancel" variant="default" v-if="user_edit.avatar && isEdit" @clicked="changeImage"></Button>
          </div>
        </div>
      </div>
    </div>
    <div class="flex w-full">
      <div class="w-1/2">
        <form-item label='Full Name'>
          <template v-slot>
            <template v-if="isEdit">
              <Input
                v-model="user_edit.name"
                placeholder="Full Name"
                :error="($v.user_edit.name.$dirty && !$v.name.required)"
              />
              <div class="flex flex-col pt-2">
                <text-error
                  v-if="$v.user_edit.name.$dirty && !$v.user_edit.name.required"
                  text="Please fill your name."
                />
              </div>
            </template>
            <p class="text-left font-bold" v-else>{{user.name}}</p>
          </template>
        </form-item>
        <form-item label='Email'>
          <template v-slot>
            <template v-if="isEdit">
              <Input
                v-model="user_edit.email"
                placeholder="Email"
                :error="($v.user_edit.email.$dirty && (!$v.user_edit.email.required || !$v.user_edit.email.email))"
              />
              <div class="flex flex-col pt-2">
                <text-error
                  v-if="$v.user_edit.email.$dirty && !$v.user_edit.email.required"
                  text="Please fill your name."
                />
                <text-error
                  v-if="$v.user_edit.email.$dirty && !$v.user_edit.email.email"
                  text="Email is not valid."
                />
              </div>
            </template>
            <p class="text-left font-bold" v-else>{{user.email}}</p>
          </template>
        </form-item>
        <form-item label='Birthdate'>
          <template v-slot>
            <template v-if="isEdit">
              <Input
                v-model="user_edit.dob"
                placeholder="Birthdate"
              />
            </template>
            <p class="text-left font-bold" v-else>{{user.dob || '-'}}</p>
          </template>
        </form-item>
        <form-item label='Email'>
          <template v-slot>
            <template v-if="isEdit">
              <Input
                v-model="user_edit.email"
                placeholder="Email"
                :error="($v.user_edit.email.$dirty && (!$v.user_edit.email.required || !$v.user_edit.email.email))"
              />
              <div class="flex flex-col pt-2">
                <text-error
                  v-if="$v.user_edit.email.$dirty && !$v.user_edit.email.required"
                  text="Please fill your name."
                />
                <text-error
                  v-if="$v.user_edit.email.$dirty && !$v.user_edit.email.email"
                  text="Email is not valid."
                />
              </div>
            </template>
            <p class="text-left font-bold" v-else>{{user.email}}</p>
          </template>
        </form-item>
        <form-item label='Bio'>
          <template v-slot>
            <template v-if="isEdit">
              <div class="relative" >
          <TextArea
            v-model="user_edit.bio"
            placeholder="Tell us about you"
            :error="$v.user_edit.bio.$dirty && !$v.user_edit.bio.maxLength"
            :maxlength="bioMaxLength"
            rows="10"
          />
                <div  class="absolute right-0 text-xs" style="bottom: 15px; right: 15px;" >{{user_edit.bio.length}}/{{bioMaxLength}}</div>
              </div>
              <div class="flex flex-col pt-2">
                <text-error v-if="$v.user_edit.bio.$dirty && !$v.user_edit.bio.maxLength" text="Maximum character for bio is 2000 characters." />
              </div>
            </template>
            <p class="text-left font-bold" v-else>{{user.bio_status == 1? (user.biodata || '-') : user.bio}}</p>
          </template>
        </form-item>
        <form-item label='Bio Status' v-if="!isEdit">
          <template v-slot>
            <div class="text-left">
              <span  v-if="(user.bio_status == 1 || (user.bio_status == 0 && user.bio!=null))" v-bind:class="user.bio_status == 1? 'text-green-600 bg-green-200' : 'text-orange-600 bg-orange-200'" class="text-xs text-center font-semibold inline-block py-1 px-2 uppercase rounded uppercase last:mr-0 mr-1 w-64">{{user.bio_status == 1?'Published':'Waiting for Review'}}</span>
            </div>
          </template>
        </form-item>
        <form-item label='Language'>
          <template v-slot>
            <template v-if="isEdit">
              <el-select v-model="user_edit.language" filterable placeholder="Select Language" class="w-full">
                <el-option
                  v-for="item in dataLanguages"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              <div class="flex flex-col pt-2">
                <text-error v-if="$v.user_edit.language.$dirty && !$v.user_edit.language.required" text="Please choose language." />
              </div>
            </template>
            <p v-else class="text-left font-bold">{{ getLanguageLabel() }}</p>
          </template>
        </form-item>
        <form-item label='Password' v-if="isEdit">
          <template v-slot>
            <div class="relative">
              <Input
                :type="showPassword?'text':'password'"
                v-model="user_edit.password"
                placeholder="Password"
              />
              <a class="absolute top-0 right-0 mr-2 mt-3 " @click="showPassword=!showPassword" style="cursor:pointer">
                <i class="fa" :class="showPassword?'fa-eye-slash':'fa-eye'"></i>
              </a>
            </div>
          </template>
        </form-item>
        <form-item label='Upload File Agreement'>
          <template v-slot>
            <template v-if="isEdit">
              <div class="flex-1" >
                <input
                  v-if="!user_edit.file_agreement"
                  type="file"
                  class="block border border-grey-light w-full p-3 rounded"
                  name="file_agreement"
                  @change="onFileChangeAgreement"
                  accept="application/pdf"
                />
                <div v-if="user_edit.file_agreement" class="flex" >
                  <a :href="user.file_agreement" target="_blank" v-if="user.file_agreement == user_edit.file_agreement"
                     class="underline font-bold mr-2"
                  >Agreement Link</a>
                  <span class="mr-2 text-gray-700 font-medium" v-else>{{user_edit.file_agreement_name}}</span>
                  <a @click="changeFileAgreement" class="cursor-pointer"><font-awesome-icon :icon="['fas', 'times-circle']"   /></a>
                </div>
              </div>
            </template>
            <p v-else class="text-left">
              <a :href="user.file_agreement" v-if="user.file_agreement" target="_blank" class="underline font-bold mr-2">Agreement Link</a>
              <span v-else>-</span>
            </p>
          </template>
        </form-item>
      </div>
      <div class="w-1/2">
        <form-item label='Bank Name'>
          <template v-slot>
            <template v-if="isEdit">
              <Input
                v-model="user_edit.bank.bank"
                placeholder="Bank Name"
                :error="($v.user_edit.bank.bank.$dirty && !$v.user_edit.bank.bank.required)"
              />
              <div class="flex flex-col pt-2">
                <text-error
                  v-if="$v.user_edit.bank.bank.$dirty && !$v.user_edit.bank.bank.required && showErrorBank"
                  text="Bank Name must be filled."
                />
              </div>
            </template>
            <p v-else class="text-left font-bold">{{ user.bank.bank || '-' }}</p>
          </template>
        </form-item>
        <form-item label='Account Name'>
          <template v-slot>
            <template v-if="isEdit">
              <Input
                v-model="user_edit.bank.account_name"
                placeholder="Account Name"
                :error="($v.user_edit.bank.account_name.$dirty && !$v.user_edit.bank.account_name.required)"
              />
              <div class="flex flex-col pt-2">
                <text-error
                  v-if="$v.user_edit.bank.account_name.$dirty && !$v.user_edit.bank.account_name.required && showErrorBank"
                  text="Account Name must be filled."
                />
              </div>
            </template>
            <p v-else class="text-left font-bold">{{ user.bank.account_name || '-' }}</p>
          </template>
        </form-item>
        <form-item label='Account Number'>
          <template v-slot>
            <template v-if="isEdit">
              <Input
                v-model="user_edit.bank.account_number"
                placeholder="Account Number"
                :error="($v.user_edit.bank.account_number.$dirty && (!$v.user_edit.bank.account_number.required || !$v.user_edit.bank.account_number.numeric))"
              />
              <div class="flex flex-col pt-2">
                <text-error
                  v-if="$v.user_edit.bank.account_number.$dirty && !$v.user_edit.bank.account_number.required && showErrorBank"
                  text="Account Number must be filled."
                />
                <text-error
                  v-if="$v.user_edit.bank.account_number.$dirty && !$v.user_edit.bank.account_number.numeric && showErrorBank"
                  text="Must be numeric."
                />
              </div>
            </template>
            <p v-else class="text-left font-bold">{{ user.bank.account_number || '-' }}</p>
          </template>
        </form-item>
        <form-item label='Swift Code'>
          <template v-slot>
            <template v-if="isEdit">
              <Input
                v-model="user_edit.bank.swift_code"
                placeholder="Swift Code"
                :error="($v.user_edit.bank.swift_code.$dirty && !$v.user_edit.bank.swift_code.required)"
              />
              <div class="flex flex-col pt-2">
                <text-error
                  v-if="$v.user_edit.bank.swift_code.$dirty && !$v.user_edit.bank.swift_code.required && showErrorBank"
                  text="Account Number must be filled."
                />
              </div>
            </template>
            <p v-else class="text-left font-bold">{{ user.bank.swift_code || '-' }}</p>
          </template>
        </form-item>
        <form-item label='Wise ID (Wisetag)'>
          <template v-slot>
            <template v-if="isEdit">
              <Input
                v-model="user_edit.wise.handle"
                placeholder="e.g. @elianab210"
              />
            </template>
            <p v-else class="text-left font-bold">{{ wiseAccount.handle || '-' }}</p>
          </template>
        </form-item>
        <form-item label='Total Earning'>
          <template v-slot>
            <p class="text-left font-bold">${{parseFloat(user.earning).toFixed(2) || 0}}</p>
          </template>
        </form-item>
        <form-item label='Balance'>
          <template v-slot>
            <p class="text-left font-bold">${{parseFloat(user.balance).toFixed(2) || 0}}</p>
          </template>
        </form-item>
        <form-item label='MusicVerse Cut'>
          <template v-slot>
            <template v-if="isEdit">
              <Input
                v-model="user_edit.musicverse_cut"
                placeholder="Account Number"
                :error="($v.user_edit.musicverse_cut.$dirty && (!$v.user_edit.musicverse_cut.required || !$v.user_edit.musicverse_cut.numeric))"
              />
              <div class="flex flex-col pt-2">
                <text-error
                  v-if="$v.user_edit.musicverse_cut.$dirty && !$v.user_edit.musicverse_cut.required"
                  text="MusicVerse Cut must be filled."
                />
                <text-error
                  v-if="$v.user_edit.musicverse_cut.$dirty && !$v.user_edit.musicverse_cut.numeric"
                  text="Must be numeric."
                />
              </div>
            </template>
            <p v-else class="text-left font-bold">{{ user.musicverse_cut || '-' }}</p>
          </template>
        </form-item>
        <form-item label='Artist Cut'>
          <template v-slot>
            <template v-if="isEdit">
              <Input
                v-model="user_edit.artist_cut"
                placeholder="Account Number"
                :error="($v.user_edit.artist_cut.$dirty && (!$v.user_edit.artist_cut.required || !$v.user_edit.artist_cut.numeric))"
              />
              <div class="flex flex-col pt-2">
                <text-error
                  v-if="$v.user_edit.artist_cut.$dirty && !$v.user_edit.artist_cut.required"
                  text="Artist Cut must be filled."
                />
                <text-error
                  v-if="$v.user_edit.artist_cut.$dirty && !$v.user_edit.artist_cut.numeric"
                  text="Must be numeric."
                />
              </div>
            </template>
            <p v-else class="text-left font-bold">{{ user.artist_cut || '-' }}</p>
          </template>
        </form-item>
      </div>
    </div>
    <div  class="flex flex-col md:flex-row mt-4 pt-4 border-t">
      <Button v-if="isEdit && !isReviewing" @clicked="save" label="Save"/>
      <Button v-if="isReviewing" @clicked="publish" :label="isEdit?'Save and Publish':'Publish'"/>
      <Button variant="default" @clicked="toggleEdit" :label="labelToggleEdit"/>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters, mapActions } from 'vuex';
import { validationMixin } from 'vuelidate';
import helpersMixin from '../../mixins/helpers.mixins';
import { required, numeric, maxLength, email } from 'vuelidate/lib/validators';
import Vue from 'vue';
import Card from '@/components/Layout/Card.vue';
import { Button, FormItem, Input, Select, TextArea, TextError } from '@/components/Layout/Form';
import imgPlaceholder from '@/assets/image-placeholder.jpeg';

export default {
  name: 'ArtistProfile',
  mixins: [validationMixin, helpersMixin],
  props: {
    user: {
      type: Object,
      default: () => ({
        id: '',
        name: '',
        email: '',
        dob: '',
        bio: '',
        genre: '',
        avatar: '',
        bio_status: '',
        language: '',
        file_agreement: null,
        bank: {
          bank: '',
          account_name: '',
          account_number: '',
          swift_code: '',
        },
        musicverse_cut: 0,
        artist_cut: 0,
      }),
    },
    isReviewing: {
      type: Boolean,
      default: () => (false),
    },
  },
  data() {
    return {
      bioMaxLength: 2000,
      dataLanguages: [],
      showPassword: false,
      user_edit: {
        name: '',
        email: '',
        dob: '',
        bio: '',
        genre: '',
        avatar: '',
        bio_status: '',
        language: '',
        file_agreement: null,
        file_agreement_name: null,
        password: '',
        bank: {
          bank: '',
          account_name: '',
          account_number: '',
          swift_code: '',
        },
        // the wise_link column stores the artist's Wisetag (e.g. "@elianab210")
        wise: {
          handle: '',
        },
        musicverse_cut: 0,
        artist_cut: 0,
      },
      isEdit: false,
      isErrorImage: false,
      isFileLarge: false,
      showErrorBank: false,
      isError: false,
      imgPlaceholder
    };
  },
  validations() {
    const rules = {
      user_edit: {
        name: {
          required,
          maxLength: maxLength(100),
        },
        email: {
          required,
          email,
          maxLength: maxLength(100),
        },
        bio: {
          maxLength: maxLength(2000),
        },
        musicverse_cut: {
          required,
          numeric,
        },
        artist_cut: {
          required,
          numeric,
        },
        bank: {
          bank: {},
          account_name: {},
          account_number: {},
          swift_code: {},
        },
        language: { required },
      },
    };
    if (this.user_edit.bank.bank !== '' || this.user_edit.bank.account_number !== '' || this.user_edit.bank.account_name !== '' || this.user_edit.bank.swift_code !== '') {
      rules.user_edit.bank = {
        bank: {
          required,
        },
        account_number: {
          required, numeric,
        },
        account_name: {
          required,
        },
        swift_code: {
          required,
        },
      };
    }
    return rules;
  },
  computed: {
    ...mapGetters('NotificationModule', ['getErrorCode', 'getMessage', 'getStatus']),
    // the wise_link column stores the artist's Wisetag (e.g. "@elianab210")
    // or legacy JSON; only the Wisetag key is used for direct Wise-to-Wise payouts
    wiseAccount() {
      const empty = { handle: '' };
      if (!this.user.wise_link) {
        return empty;
      }
      const wiseLink = String(this.user.wise_link).trim();
      if (!wiseLink.startsWith('{')) {
        // raw Wisetag identifier
        return { handle: wiseLink };
      }
      try {
        const parsed = JSON.parse(this.user.wise_link);
        return {
          handle: (parsed && parsed.wise_handle) || '',
        };
      } catch (err) {
        return empty;
      }
    },
    validCal() {
      const total = parseInt(this.user_edit.musicverse_cut) + parseInt(this.user_edit.artist_cut);
      return total > 0 && total <= 100;
    },
    labelToggleEdit() {
      return this.isEdit ? 'Cancel Edit' : 'Edit';
    },
  },
  watch: {
    user: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val !== undefined || val !== null) {
          if (val.bank === null || val.bank === undefined) {
            this.user.bank = Object.assign({}, {
              bank: '',
              account_name: '',
              account_number: '',
              swift_code: '',
            });
          }
          this.setUserEditValue();
          this.user_edit.bio = this.user.bio_status == 1 ? (this.user.biodata || '-') : this.user.bio;
          this.isEdit = false;
          this.$v.$reset();
          this.isFileLarge = false;
          this.isErrorImage = false;
          this.showErrorBank = false;
        }
      },
    },
  },
  mounted() {
    this.dataLanguages = this.getLanguages();
  },
  methods: {
    ...mapActions('ArtistModule', ['requestPublishArtist', 'requestUpdateArtist']),
    toggleEdit() {
      this.isEdit = !this.isEdit;
      if (this.isEdit) {
        this.setUserEditValue();
        this.user_edit.bio = this.user.bio_status == 1 ? (this.user.biodata || '-') : this.user.bio;
      } else {
        this.$v.$reset();
        this.isFileLarge = false;
        this.isErrorImage = false;
        this.showErrorBank = false;
        this.setUserEditValue();
        this.user_edit.bio = this.user.bio_status == 1 ? (this.user.biodata || '-') : this.user.bio;
      }
    },
    setUserEditValue() {
      this.user_edit = {
        name: this.user.name,
        email: this.user.email,
        dob: this.user.dob,
        bio: '',
        genre: this.user.genre,
        avatar: this.user.avatar,
        bio_status: this.user.bio_status,
        language: this.user.language || '',
        file_agreement: this.user.file_agreement || null,
        file_agreement_name: this.user.file_agreement || null,
        password: '',
        bank: {
          bank: this.user.bank.bank,
          account_name: this.user.bank.account_name,
          account_number: this.user.bank.account_number,
          swift_code: this.user.bank.swift_code,
        },
        wise: {
          handle: this.wiseAccount.handle,
        },
        musicverse_cut: this.user.musicverse_cut,
        artist_cut: this.user.artist_cut,
      };
    },
    changeValueMVCut(event) {
      if (!isNaN(event.target.value)) {
        this.user_edit.artist_cut = 100 - event.target.value;
        if (this.user_edit.artist_cut < 0) {
          this.user_edit.artist_cut = 0;
        }
      } else {
        this.user_edit.artist_cut = 100;
        this.user_edit.musicverse_cut = 0;
      }
    },
    changeValueArtistCut(event) {
      if (!isNaN(event.target.value)) {
        this.user_edit.musicverse_cut = 100 - event.target.value;
        if (this.user_edit.musicverse_cut < 0) {
          this.user_edit.musicverse_cut = 0;
        }
      } else {
        this.user_edit.musicverse_cut = 100;
        this.user_edit.artist_cut = 0;
      }
    },
    onFileChange(e) {
      const file = e.target.files[0];
      if (file.size > 1024 * 1024) {
        this.$v.dirty = true;
        this.isFileLarge = true;
      }
      this.user_edit.avatar = URL.createObjectURL(file);
    },
    changeImage() {
      if (this.isEdit) {
        this.user_edit.avatar = null;
      }
    },
    processFileBlob(response) {
      const file = new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(response.data);
        reader.onloadend = () => {
          resolve(reader.result);
        };
      });
      return file.then(data => data);
    },
    async buildData() {
      const dataArtist = new FormData();
      let data = {
        id: this.user.id,
        name: this.user_edit.name,
        email: this.user_edit.email,
        password: this.user_edit.password,
        bio: this.user_edit.bio,
        dob: this.user_edit.dob,
        language: this.user_edit.language,
        artist_cut: this.user_edit.artist_cut,
        musicverse_cut: this.user_edit.musicverse_cut,
      };
      dataArtist.append('id',this.user.id);
      dataArtist.append('name',this.user_edit.name);
      dataArtist.append('email',this.user_edit.email);
      dataArtist.append('password',this.user_edit.password);
      dataArtist.append('bio',this.user_edit.bio);
      dataArtist.append('dob',this.user_edit.dob);
      dataArtist.append('language',this.user_edit.language);
      dataArtist.append('artist_cut',this.user_edit.artist_cut);
      dataArtist.append('musicverse_cut',this.user_edit.musicverse_cut);
      if (this.user_edit.bank.bank !== '' && this.user_edit.bank.account_name !== '' && this.user_edit.bank.account_number !== '' && this.user_edit.bank.swift_code !== '') {
        data.bank_account = {
          bank: this.user_edit.bank.bank,
          account_number: this.user_edit.bank.account_number,
          account_name: this.user_edit.bank.account_name,
          swift_code: this.user_edit.bank.swift_code,
        };
        dataArtist.append('bank_account[bank]',this.user_edit.bank.bank);
        dataArtist.append('bank_account[account_number]',this.user_edit.bank.account_number);
        dataArtist.append('bank_account[account_name]',this.user_edit.bank.account_name);
        dataArtist.append('bank_account[swift_code]',this.user_edit.bank.swift_code);
      }
      data.wise = {
        handle: this.user_edit.wise.handle,
      };
      dataArtist.append('wise[handle]', this.user_edit.wise.handle);
      if (!!this.user_edit.avatar && this.user_edit.avatar != this.user.avatar) {
        const resultimage = await axios({
          method: 'get',
          url: this.user_edit.avatar,
          responseType: 'blob',
        }).then(this.processFileBlob);
        dataArtist.append('avatar', resultimage);
      }
      if (!!this.user_edit.file_agreement && this.user_edit.file_agreement != this.user.file_agreement) {
        const ext = this.getExt(this.user_edit.file_agreement_name);
        if (ext != 'pdf') {
          const resultFileAgreement = await axios({
            method: 'get',
            url: this.user_edit.file_agreement,
            responseType: 'blob',
          }).then(this.processFileBlob);
          dataArtist.append('file_agreement', resultFileAgreement);
          dataArtist.append('file_agreement_type', 'image');
        } else {
          dataArtist.append('file_agreement', this.user_edit.file_agreement);
          dataArtist.append('file_agreement_type', 'pdf');
        }
      }
      return dataArtist;
    },
    async save() {
      this.$v.$touch();
      const isValid = !this.$v.$invalid;
      if (!isValid && (this.user_edit.bank.bank !== '' || this.user_edit.bank.account_number !== '' || this.user_edit.bank.account_name !== '' || this.user_edit.bank.swift_code !== '')) {
        this.showErrorBank = true;
      } else {
        this.showErrorBank = false;
        this.isErrorImage = this.user_edit.avatar == null;
        if (!this.isErrorImage && !this.isFileLarge) {
          const data = await this.buildData();
          await this.requestUpdateArtist(data);
          if (this.getStatus != 200 && this.getErrorCode == 'error-update-artist-admin') {
            this.isError = true;
            this.$swal('Error', this.getMessage, 'error');
          } else {
            this.toggleEdit();
            this.$emit('on-save', true);
          }
        }
      }
    },
    async publish() {
      let isError = false;
      if (this.isEdit) {
        this.$v.$touch();

        this.isErrorImage = this.user_edit.avatar == null;
        isError = this.$v.$invalid || this.isErrorImage || this.isFileLarge;
      }
      if (!isError) {
        Vue.swal({
          title: 'Publish Artist',
          text: 'Are you sure want to publish this artist?',
          icon: 'warning',
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          showCancelButton: true,
        }).then(async (result) => {
          if (result.value) {
            let data = await this.buildData();
            data.append('status','1');
            await this.requestPublishArtist(data);
            if (this.getStatus != 200 && this.getErrorCode == 'error-publish-artist-admin') {
              this.isError = true;
              this.$swal('Error', this.getMessage, 'error');
            } else {
              this.toggleEdit();
              this.$emit('on-save', true);
            }
          }
        });
      }
    },
    getLanguageLabel(){
      if(this.user.language){
        const find = this.dataLanguages.find((l) => {
          return l.value === this.user.language
        })
        if(find){
          return find.label
        }
      }
      return '-'
    },
    getExt(name) {
      const fileInfo = name.split('.');
      return fileInfo[fileInfo.length - 1];
    },
    onFileChangeAgreement(e) {
      const file = e.target.files[0];
      // console.log(file);
      this.user_edit.file_agreement = this.getExt(file.name) == 'pdf' ? file : URL.createObjectURL(file);
      this.user_edit.file_agreement_name = file.name;
    },
    changeFileAgreement() {
      this.user_edit.file_agreement = null;
    },
  },
  components: {
    Card, Button,
    FormItem,
    Input,
    TextArea,
    TextError,
    Select,
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/ArtistContent/ArtistProfile.vue